export default __webpack_public_path__ + "static/media/rpl2.5d493d17.jpg";